var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:['fish image', {'disabled': _vm.disabled, 'bordered': _vm.bordered, 'rounded': _vm.rounded}, _vm.shape],attrs:{"src":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }